export const trendCursorsAsArray = (trendCursors) => Object.values(trendCursors);
